import React from 'react';
import { Link } from 'react-router-dom';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

function EmptyOrder() {
  return (
    <div className="can-empty-card">
      <div className="can-empty-icon-wrap">
        <CheckCircleOutlineOutlinedIcon />
      </div>

      <h3 className="can-empty-title">No Cancelled Orders</h3>

      <p className="can-empty-sub">
        You don't have any cancelled orders! All your items are either being actively fulfilled or successfully delivered to your doorstep.
      </p>

      <div className="can-empty-actions">
        <Link to="/orders/Details/me" className="can-btn-active">
          <ShoppingBagOutlinedIcon fontSize="small" />
          <span>View Active Orders</span>
        </Link>

        <Link to="/marketplace/search?type=shops" className="can-btn-back">
          <StorefrontOutlinedIcon fontSize="small" />
          <span>Explore Nearby Shops</span>
        </Link>

        <Link to="/userprofile" className="can-btn-back">
          <span>Back to My Profile</span>
        </Link>
      </div>
    </div>
  );
}

export default EmptyOrder;